module.exports = __webpack_public_path__ + "static/media/52_A.310cd287.png";